import React from 'react'

function SvgFileIcon() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="32" height="32" rx="16" fill="#E0EAFF" />
      <path
        d="M19.3334 11.5129V14.2666C19.3334 14.64 19.3334 14.8266 19.4061 14.9692C19.47 15.0947 19.572 15.1967 19.6974 15.2606C19.84 15.3333 20.0267 15.3333 20.4001 15.3333H23.1538M23.3334 16.6587V21.4666C23.3334 22.5867 23.3334 23.1467 23.1154 23.5746C22.9237 23.9509 22.6177 24.2569 22.2414 24.4486C21.8136 24.6666 21.2535 24.6666 20.1334 24.6666H15.8667C14.7466 24.6666 14.1866 24.6666 13.7588 24.4486C13.3824 24.2569 13.0765 23.9509 12.8847 23.5746C12.6667 23.1467 12.6667 22.5867 12.6667 21.4666V14.5333C12.6667 13.4131 12.6667 12.8531 12.8847 12.4253C13.0765 12.0489 13.3824 11.743 13.7588 11.5512C14.1866 11.3333 14.7466 11.3333 15.8667 11.3333H18.0079C18.4971 11.3333 18.7417 11.3333 18.9719 11.3885C19.176 11.4375 19.371 11.5183 19.55 11.628C19.7518 11.7517 19.9248 11.9246 20.2707 12.2705L22.3962 14.396C22.7421 14.7419 22.915 14.9148 23.0387 15.1167C23.1484 15.2956 23.2292 15.4907 23.2782 15.6948C23.3334 15.925 23.3334 16.1696 23.3334 16.6587Z"
        stroke="#444CE7"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2"
        y="2"
        width="32"
        height="32"
        rx="16"
        stroke="#EEF4FF"
        strokeWidth="4"
      />
    </svg>
  )
}

export default SvgFileIcon
